import React from "react";
import { FaExternalLinkAlt, FaStar } from "react-icons/fa";
import { isImageUrl } from "../utils/media";
import RevealOnScroll from "./RevealOnScroll";
import EnhancedButton from "./EnhancedButton";

const FeaturedProject = ({ project, loading }) => {
  if (loading) {
    return (
      <div className="mb-12 h-64 rounded-xl bg-gray-100 dark:bg-brand-darker animate-pulse" />
    );
  }

  if (!project) return null;

  return (
    <RevealOnScroll animation="slideInLeft" className="mb-12">
      <div className="flex items-center justify-center gap-2 mb-4">
        <FaStar className="text-brand-gold" />
        <h3 className="text-2xl md:text-3xl font-bold text-gradient">
          Featured Project
        </h3>
      </div>
      <div className="grid md:grid-cols-2 gap-6 rounded-xl overflow-hidden border border-gray-200 dark:border-brand-purple/20 bg-gradient-to-br from-gray-50 to-white dark:from-brand-darker dark:to-[#2a2a2a] hover:border-brand-gold/40 hover:shadow-glow transition-all duration-300">
        <div className="relative h-56 md:h-auto min-h-[14rem] bg-gradient-to-br from-brand-gold/10 to-brand-purple/10 overflow-hidden">
          {project.thumbnail &&
            (isImageUrl(project.thumbnail) ? (
              <img
                src={project.thumbnail}
                alt={`Screenshot of ${project.title}`}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover"
              />
            ) : (
              <iframe
                src={project.thumbnail}
                className="absolute inset-0 w-full h-full border-0"
                title={project.title}
                loading="lazy"
                sandbox="allow-scripts allow-same-origin"
              />
            ))}
        </div>
        <div className="p-6 md:p-8 flex flex-col justify-center">
          <h4 className="text-2xl font-bold text-brand-gold mb-3">
            {project.title}
          </h4>
          <p className="text-gray-600 dark:text-brand-cream/80 mb-6 line-clamp-4">
            {project.description}
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            {project.link && (
              <EnhancedButton
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                variant="primary"
                size="md"
                icon={<FaExternalLinkAlt />}
              >
                View Live
              </EnhancedButton>
            )}
            <EnhancedButton href="/projects" variant="outline" size="md">
              All Projects
            </EnhancedButton>
          </div>
        </div>
      </div>
    </RevealOnScroll>
  );
};

export default FeaturedProject;
